// extracted by mini-css-extract-plugin
export default {"modal":"gJT19T1vgdCE265tCoQO__modal___","modalDescription":"Jbk5QKusk3NMCrJkQUXk__modalDescription___"};